import React, { useState, useEffect } from 'react'
import PopupModal from '../../../../components/popup-bottom-modal'
import { getCloseReasonEnum, closeShare } from '../../api'
import TagList from '../tag-list'
import Toast from '@xpeng/rc-toast'
import { trackGdp } from '../../../../utils/gio-report'
import { UserTypeEnum } from '../../../../api/pile'

import './index.less'
import { removeStationDtl } from '../../shared/cache'

interface SharingCloseModalPropsRule {
  visible: boolean
  setVisible: (status: boolean) => void
  stationId?: string
  incomeTotal: any
  userInfo: any
}

const SharingCloseModal = (props: SharingCloseModalPropsRule) => {
  const { visible, setVisible, stationId, incomeTotal, userInfo } = props
  const [closeReasonList, setCloseReasonList] = useState<any[]>([])
  const [selectedReason, setSelectedReason] = useState<any[]>([])
  useEffect(() => {
    getData()
  }, [])
  useEffect(() => {
    if (visible) {
      trackGdp('P20075', 'B008', {
        userId: userInfo?.uid,
        userType: UserTypeEnum[userInfo?.type]
      })
    }
  }, [visible])
  const getData = async () => {
    const { data } = await getCloseReasonEnum()
    if (data?.length) {
      setCloseReasonList(data)
    }
  }
  const close = async () => {
    trackGdp('P20075', 'B009', {
      userId: userInfo?.uid,
      userType: UserTypeEnum[userInfo?.type],
      user_type: UserTypeEnum[userInfo?.type],
    })
    if (!selectedReason?.length) {
      Toast.show('请选择关闭原因', {
        containerStyle: {
          zIndex: 9999
        }
      })
      return
    }
    if (stationId) {
      const closeRes = await closeShare({
        stationId,
        reasonType: selectedReason.map(i => i.code)
      })
      if (closeRes?.code === 200) {
        Toast.show('关闭成功', {
          containerStyle: {
            zIndex: 9999
          }
        })
        setVisible(false)
        removeStationDtl(stationId)
        location.reload()
      } else {
        Toast.show('关闭失败', {
          containerStyle: {
            zIndex: 9999
          }
        })
      }
    } else {
      Toast.show('无站点id', {
        containerStyle: {
          zIndex: 9999
        }
      })
    }

  }
  return (
    visible
      ?
      <PopupModal
        visible={visible}
        title='确认关闭共享'
        onClose={() => { setVisible(false) }}
      >
        {/* 这个单纯是尝试修复 iphone12 打开弹窗会闪一下的问题 */}
        {(visible && closeReasonList?.length > 0) &&
          <div className='close-container'>
            <div className='tip'>关闭后，你的家充桩信息不会再对外展示，已经申请通过的用户也无法继续使用你的家充桩</div>
            {!!incomeTotal?.orderCount && <div className='tip-heightlight'>过去30天共享过{incomeTotal?.orderCount}次，累计收益{incomeTotal?.incomeAmt || '--'}元</div>}
            <div className='reason-title'>
              <div className='reason-required-icon'>*</div>
              <div className='reason-title-text'>选择原因</div>
            </div>
            <div className='tag-list-container'>
              <TagList
                list={
                  closeReasonList
                }
                onChange={(data) => setSelectedReason(data as any)}
                multi={true}
              />
            </div>
            <div className='btn-container'>
              <div
                className='confirm-btn'
                onClick={close}
              >
                确认关闭
              </div>
              <div
                className='cancel-btn'
                onClick={() => { setVisible(false) }}
              >
                再想想
              </div>
            </div>
          </div>
        }
      </PopupModal>
      : null
  )
}

export default SharingCloseModal